async function doRequest({
                             onProgress = undefined,
                             onProcessing = undefined,
                             uri,
                             method,
                             body,
                             contentType,
                             credentials = 'include'
                         }) {
    const options = {
        method: method,
        mode: 'cors',
        credentials: credentials
    }
    const token = sessionStorage.getItem('jwt')
    const headers = new Headers()
    if (token !== undefined && token !== null) {
        headers.set('Authorization', token)
    }
    if (body !== undefined) {
        console.log("Body is " + body);
        if (contentType === 'application/json') {
            options.body = JSON.stringify(body)
            headers.append('Content-Type', contentType)
        } else {
            console.log("Have a file ");
            const form = new FormData()
            form.append(body.field, body.body, body.body.name)
            options.body = form
        }
    }
    options.headers = headers
    console.log("Method is: " + method + " - processing....");
    if (uri.endsWith('/fems') && method === 'POST') {
        return uploadFile(body.body, uri, options, onProgress)
            .then(async (res) => {
                const response = JSON.parse(res); // Parse the JSON text
                const taskId = response["taskId"]; // Access taskId property
                console.log("Value of taskId is " + taskId);
                // Handle the long-running task
                console.log("Got the file data processed")
                if (onProcessing !== undefined) {
                    onProcessing[1](true);
                }
                return await pollStatus(taskId, options, onProcessing); // Start polling for status
            })
    } else {
        // Using fetch directly instead of fetchWithTimeout
        return await fetch(uri, options);
    }
}

async function pollStatus(taskId, options, onProcessing) {
    console.log("Task ID inside pollStatus " + taskId);

    while (true) {
        try {
            const response = await fetch(`https://sshm4damsapi.fly.dev/status/${taskId}`, {
                method: "GET",
                mode: 'cors',
                credentials: options.credentials,
                headers: options.headers
            });
            const fileUploadedProgress = response.status;
            console.log('Task status:', fileUploadedProgress);

            if (fileUploadedProgress === 200) {
                // Handle completion (e.g., show results to the user)
                console.log('Task completed:', response.result);
                return response; // Resolve the promise with the response
            } else if (fileUploadedProgress >= 400) {
                // Handle error
                console.error('Task failed');
                throw new Error('Task failed when returning file data'); // Reject the promise
            } else {
                if (onProcessing !== undefined) {
                    onProcessing[0]((dots) => dots + 1);
                    console.log("Checking mesh generation...");
                }
                await new Promise(resolve => setTimeout(resolve, 5000)); // Wait for 5 seconds before next poll
            }
        } catch (error) {
            console.error('Error during fetch:', error);
            //await new Promise(resolve => setTimeout(resolve, 5000)); // Wait for 5 seconds before retrying
        }
    }
}


async function uploadFile(file, uri, options, onProgress) {
    return new Promise((resolve, reject) => {
        if (file.size / 1048576 > 15) {
            reject(new Error('File upload failed. File too large. Max 15Mb'));
        }

        const xhr = new XMLHttpRequest();
        const formData = new FormData();

        // Append file to the form data
        formData.append('fem', file, file.name);

        // Configure the request
        xhr.open('POST', uri, true);

        // Set up any headers you need
        xhr.setRequestHeader('Authorization', sessionStorage.getItem('jwt'));

        // Set up a listener for the request to complete
        xhr.onload = function () {
            if (xhr.status === 200) {
                console.log('File uploaded successfully');
                resolve(xhr.responseText);
            } else {
                console.error('File upload failed', xhr.statusText);
                reject(new Error('File upload failed: ' + xhr.statusText));
            }
        };

        // Optional: Monitor the progress of the upload
        xhr.upload.onprogress = function (event) {
            if (event.lengthComputable) {
                const percentageComplete = (event.loaded / event.total) * 100;
                console.log(`Uploaded ${percentageComplete}%`);
                if (onProgress !== undefined) {
                    onProgress(percentageComplete.toFixed());
                }
            }
        };

        // Optional: Handle any errors that occur here
        xhr.onerror = function () {
            console.error('Error during file upload', xhr.statusText);
            reject(new Error('Error during file upload: ' + xhr.statusText));
        };

        // Send the request
        xhr.send(formData);
    });
}


export default doRequest;
